import _ from "lodash";
import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {reduxForm, SubmissionError} from "redux-form";
import {
    RestService,
    fwUrlUtils,
    RestUtils,
    validateEmail,
    I18nMessage
} from "assecobs-faktor-web-common/index";
import ResetPasswordComponent from "../components/ResetPasswordComponent";
import ResetPasswordSuccessComponent from "../components/ResetPasswordSuccessComponent";

const RESET_PASSWORD_URL = fwUrlUtils.getApiUrl("/webapi/password/resetPassword");

const doResetPassword = Symbol();
const handleResetPasswordResponse = Symbol();

class ResetPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            resetSuccess: false
        }
    }

    async [doResetPassword](values, csrf) {

        return await RestService.postJSON(RESET_PASSWORD_URL, values, {
            headers: {
                [csrf.headerName]: csrf.token
            }
        });
    }

    [handleResetPasswordResponse](resetPasswordResponse) {
        if (resetPasswordResponse.success) {
            this.setState({resetSuccess: true});
        } else {
            throw new SubmissionError({
                _error: resetPasswordResponse.errorMessage ||
                <I18nMessage id="enum.PasswordChangeStatus.INVALID_USERNAME_OR_EMAIL"/>
            })
        }
    }

    submit = async (values) => {
        if (_.isEmpty(values.login)) {
            throw new SubmissionError({
                _error: <I18nMessage id="fw.authentication.username.empty" />
            })
        } else if (_.isEmpty(values.email)) {
            throw new SubmissionError({
                _error: <I18nMessage id="fw.authentication.email.empty" />
            })
        } else if (!validateEmail(values.email)) {
            throw new SubmissionError({
                _error: <I18nMessage id="fw.authentication.changePassword.invalidEmail"/>
            })
        }

        const csrf = await RestUtils.getCsrf();
        const resetPasswordResponse = await this[doResetPassword](values, csrf);
        this[handleResetPasswordResponse](resetPasswordResponse);
    };

    redirectToLoginPage = () => {
        window.location.href = fwUrlUtils.getContextUrl("/login");
    };

    render() {
        const {error, submitting, handleSubmit, intl} = this.props;

        if (this.state.resetSuccess) {
            return <ResetPasswordSuccessComponent onClick={this.redirectToLoginPage} />
        }

        return <ResetPasswordComponent error={error}
                                       submitting={submitting || this.state.resetSuccess}
                                       submit={this.submit}
                                       handleCancel={this.redirectToLoginPage}
                                       intl={intl}
                                       handleSubmit={handleSubmit}/>;
    }
}

export default connect()(reduxForm({
    form: 'resetForm'
})(injectIntl(ResetPassword)))
